// Phase 2.27 live-deploy fix:
// On production with a custom domain (amdiris.com), the build-time
// REACT_APP_BACKEND_URL may point to a different host than the one the user
// is browsing. The browser then enforces CORS, and Emergent's ingress
// returns `Access-Control-Allow-Origin: *` together with
// `Access-Control-Allow-Credentials: true` — a combination browsers reject
// for credentialed (cookie-bearing) requests. Authentication then fails with
// a confusing "Unable to verify account" error.
//
// Fix: when running in a browser, prefer the SAME ORIGIN as the page being
// viewed (relative URLs). Emergent's Kubernetes ingress routes `/api/*` to
// the backend regardless of which host the user landed on, so this is
// always correct. We only fall back to the env-var value during SSR or
// non-browser contexts (which we don't have).

function resolveApiBase() {
  // Browser → use the current page's origin so requests stay same-origin.
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  // Non-browser fallback (tests, SSR, etc.)
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const API_BASE = resolveApiBase();
export const API = `${API_BASE}/api`;
